import { render, staticRenderFns } from "./CourseNameModule.vue?vue&type=template&id=fb13579a&"
import script from "./CourseNameModule.vue?vue&type=script&lang=js&"
export * from "./CourseNameModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports